import { getTrafficTrackUrl } from '~/utils/get-traffic-track-uri'

export default defineNuxtPlugin(async () => {
  const trackUrl = getTrafficTrackUrl()

  const urlParams = new URLSearchParams(window.location.search)
  const utmSource = urlParams.get('utm_source')
  const utmMedium = urlParams.get('utm_medium')
  const utmCampaign = urlParams.get('utm_campaign')
  const customSrc = urlParams.get('src')
  const gclid = urlParams.get('gclid')
  const referrer = document.referrer.toLowerCase()

  let source = 'Direct'
  let medium = 'none'

  if (utmSource) {
    source = utmSource
    if (utmMedium) {
      medium = utmCampaign ? `${utmMedium} (${utmCampaign})` : utmMedium
    } else {
      medium = utmCampaign || 'utm'
    }
  } else if (gclid) {
    source = 'google'
    medium = 'cpc'
  } else if (customSrc) {
    source = customSrc
    medium = 'shortlink'
  } else if (referrer) {
    if (referrer.includes('instagram.com')) {
      source = 'instagram'
      medium = 'social'
    } else if (referrer.includes('t.me') || referrer.includes('telegram.org')) {
      source = 'telegram'
      medium = 'social'
    } else if (referrer.includes('wa.me') || referrer.includes('whatsapp.com')) {
      source = 'whatsapp'
      medium = 'social'
    } else if (referrer.includes('google.com')) {
      source = 'google'
      medium = 'organic'
    } else {
      try {
        source = new URL(referrer).hostname.replace('www.', '')
        medium = 'referral'
      } catch {
        source = 'Unknown'
        medium = 'none'
      }
    }
  }

  const data = {
    event: 'traffic_data',
    source,
    medium,
    pathname: window.location.pathname,
    full_url: window.location.href,
    referrer: document.referrer,
    timestamp: new Date().toISOString(),
  }

  if (import.meta.env.PROD) {
    const w = window as any
    w.dataLayer = w.dataLayer || []
    w.dataLayer.push(data)
  }

  try {
    await $fetch(trackUrl, { method: 'POST', body: data })
  } catch (err) {
    console.error('Failed to send traffic data:', err)
  }
})
